import { toast } from 'react-toastify';

class ToastUtility {
    public showSuccessToast(message: string) {
        toast.success(message, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
        })
    }

    public showErrorToast(message: string) {
        toast.error(message, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
        })
    }

    // This toast is one that does not auto-close
    showGenericToast(message: string) {
        toast(message, {
            position: "top-right",
            autoClose: false,
            hideProgressBar: true,
            closeOnClick: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
        })
    }

}

const toastUtility = new ToastUtility();
export default toastUtility;